import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const MiniZillow: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.23292 4.04476C9.30154 4.02952 9.33203 4.05239 9.37367 4.09813C9.61001 4.36086 10.3653 5.28335 10.5706 5.53494C10.6087 5.58068 10.5823 5.63053 10.5518 5.65692C9.02708 6.84625 7.3305 8.53113 6.38515 9.7357C6.36638 9.76268 6.38163 9.76268 6.39688 9.75857C8.04361 9.04955 11.9124 7.91711 13.6547 7.60101V5.39419L6.83554 0L0.00463867 5.39009V7.80275C2.11994 6.5454 7.01441 4.5972 9.23292 4.04476Z"
        fill="#006AFF"
      />
      <path
        d="M3.68228 13.3158C3.6254 13.3463 3.57907 13.3387 3.53333 13.2929L2.26016 11.7758C2.22614 11.7336 2.22204 11.7107 2.26778 11.6462C3.25183 10.2053 5.2604 7.95973 6.5412 7.01085C6.56407 6.9956 6.55644 6.97625 6.52947 6.98798C5.19531 7.42254 1.40277 9.05405 0 9.84694V15.0001H13.6507V10.0375C11.7905 10.3536 6.21748 12.0121 3.68228 13.3158Z"
        fill="#006AFF"
      />
    </svg>
  )
})

MiniZillow.displayName = 'MiniZillow'
